import { Grid, Layout, theme } from 'antd'
import { Outlet } from 'react-router-dom'
import { AppHeader } from './AppHeader'
import { CONTENT_MAX_WIDTH } from './layoutMetrics'
import { MobileTabBar } from './MobileTabBar'

export function AppLayout() {
  const { token } = theme.useToken()
  const screens = Grid.useBreakpoint()
  // `md` dan tor ekranda pastki tab-bar ishlatiladi — doimiy yon panel
  // telefon ekranining yarmini yeb qo'yardi
  const isMobile = screens.md === false

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppHeader isMobile={isMobile} />
      <Layout.Content
        className="xsib-content"
        style={{ padding: isMobile ? 12 : 24, background: token.colorBgLayout }}
      >
        {/* ⚠️ Chegara `layoutMetrics.ts` da va u AYNAN shu son bilan
            headerda ham ishlatiladi — ikkalasi bir vertikal o'qqa
            tushsin. Sahifalar bundan TORROQ o'z chegarasini qo'yishi
            mumkin (`ProfilePage`), lekin kengrog'ini emas. */}
        <div style={{ maxWidth: CONTENT_MAX_WIDTH, margin: '0 auto', width: '100%' }}>
          <Outlet />
        </div>
      </Layout.Content>
      {isMobile && <MobileTabBar />}
    </Layout>
  )
}
